import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import PreLoginPage from '../../../views/core/PreLoginPage';
import ph1 from '../../../images/icons/program_highlights/ph3.png';
import ph3 from '../../../images/icons/program_highlights/ph1.png';
import ph2 from '../../../images/icons/program_highlights/ph2.png';
import ph4 from '../../../images/icons/program_highlights/ph4.png';

// ES6 class-style
class ProgramHighlights extends PreLoginPage {
    constructor(props) {
        super(props);
    };

componentDidMount(){
    //console.log("Overall Features ",this.props)
}
render(){
    return(
        <div id="ProgramHighlights">
            <div className="container">			
                <div className="row">
                    <h2>Program Highlights</h2>
                    <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                        <img src={ph1} alt="Diagnostic test report" />
                        <h3 className="heading-three">Digital Curriculum</h3>
                        <p>2000+ animated lessons, games and interactive tools and a Question Bank of 100,000+ problems.</p>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                        <img src={ph2} alt="Video lesson" />
                        <h3 className="heading-three">Online accounts</h3>
                        <p>Provide differentiated and personalized learning for students and track their progress through detailed Dashboard.</p>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                        <img src={ph3} alt="Man holding bow and arrow" />
                        <h3 className="heading-three">Work attachments</h3>
                        <p>To gain an immersive exposure to digital content creation and technology skills (web and mobile apps)</p>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                        <img src={ph4} alt="Granular report card" />
                        <h3 className="heading-three">Teaching Methodology</h3>
                        <p>Incorporates Singapore’s model method, and diverse approaches for an inclusive classroom</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
}

export default ProgramHighlights;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/ProgramHighlights.js